__webpack_require__.hmrF = () => ("hot/Korei18nPluginSDK." + __webpack_require__.h() + ".hot-update.json");